import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=52f23b75&scoped=true&"
import script from "./couponDetail.vue?vue&type=script&lang=ts&"
export * from "./couponDetail.vue?vue&type=script&lang=ts&"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=52f23b75&lang=scss&scoped=true&"
import style1 from "./couponDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f23b75",
  null
  
)

export default component.exports